import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import CognitoApp from './cognito';

ReactDOM.render(<CognitoApp />, document.getElementById('root'));
